import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const HOC = (Comp) => ({
  wgw,
  news,
  zone,
  help,
  alert,
  plugin,
  config,
  search,
  header,
  calendar,
  campaign,
  ...props
}) => (
  <Comp
    wgw={wgw}
    news={news}
    zone={zone}
    help={help}
    alert={alert}
    props={props}
    plugin={plugin}
    config={config}
    search={search}
    header={header}
    calendar={calendar}
    campaign={campaign}
  />
);

const mapStateToProps = (state) => ({
  wgw: state.wgw,
  news: state.news,
  zone: state.zone,
  help: state.help,
  alert: state.alert,
  plugin: state.plugin,
  config: state.config,
  search: state.search,
  header: state.header,
  calendar: state.calendar,
  campaign: state.campaign,
});

const AppContainer = compose(
  withRouter,
  connect(mapStateToProps),
  HOC
);

export default AppContainer;
